import { IconScreen } from "@ucchub/ui";

// Success Tick Icon screen for Forgot Password
const ForgotPasswordSuccessState = ({
  onDone,
  message,
  title,
}: {
  onDone: () => void;
  title: string;
  message: string;
}) => (
  <IconScreen
    title={title}
    description={message}
    group="hifiLight"
    icon="tick-outline"
    buttonOnClick={onDone}
    buttonText="Done"
    buttonAppeareance="alt1"
  />
);

export default ForgotPasswordSuccessState;
